import SupportDialog from "../SupportDialog";

type DialogProps = {
    readonly onClose: () => void,
    readonly open: boolean,
    readonly forecastTime?: string,
};

function createEmailText( forecast: string | undefined )
{
    const time = forecast ?? "Unknown Forecast Time";
    return "Forecast Time: " + time;
}

function createEmailSubject()
{
    return "Help Request";
}

export default function WilmaSupportDialog( props: DialogProps )
{
    const emailSubject = createEmailSubject();
    const emailText = createEmailText( props.forecastTime );

    return (
        <SupportDialog
            Subject = {emailSubject}
            Body = {emailText}
            open = {props.open}
            onClose = {props.onClose}
        />
    );
}
